import type { IRegistrationPageProps } from '$/pages/registration';
import type { IRegistrationStateProps } from './useRegistrationPage';

import HeadContentSection from '$/components/blocks/HeadContentSection';
import Registration from '$/components/blocks/RegistrationPage';
import Button from '$/components/elements/Button';
import ButtonContainer from '$/components/elements/ButtonContainer';
import Container from '$/components/elements/Container';
import {
  H6Typography,
  Sub1Typography,
  Sub2Typography,
} from '$/components/elements/Typography';
import { TRACKING_ACTION } from '$/utils/tracking/consts';

interface IRegistrationViewProps
  extends IRegistrationPageProps,
    IRegistrationStateProps {}

const RegistrationView = (props: IRegistrationViewProps) => (
  <Registration {...props.elbProps}>
    <HeadContentSection>
      <Container>
        <HeadContentSection.Wrapper>
          <HeadContentSection.Title bold as="h1" color="grey7">
            <HeadContentSection.Underline>
              Du brauchst eine Finanzierung
            </HeadContentSection.Underline>{' '}
            <HeadContentSection.Underline>
              für dein Studium?
            </HeadContentSection.Underline>{' '}
            <HeadContentSection.Underline>
              Bevor du loslegst…
            </HeadContentSection.Underline>
          </HeadContentSection.Title>
          <HeadContentSection.StyledImage
            src="/images/group-2.svg"
            alt="guy sitting"
          />
        </HeadContentSection.Wrapper>
      </Container>
    </HeadContentSection>
    <Registration.Section>
      <Container>
        <H6Typography bold as="h2" color="grey7" style={{ margin: '8px 0' }}>
          Auf unserer Webseite und in den FAQ hast du vielleicht schon einiges
          über unsere Studienfinanzierung gelesen.
        </H6Typography>
        <H6Typography bold as="h2" color="grey7" style={{ margin: '8px 0' }}>
          Damit du mit den richtigen Erwartungen die Bewerbung startest, checke
          bitte noch einmal die folgenden Punkte:
        </H6Typography>
        <Sub2Typography as="p" color="grey7" style={{ margin: '8px 0' }}>
          <b>Solidarisch:</b> Unsere Studienfinanzierung funktioniert nach dem
          Prinzip eines umgekehrten Generationenvertrags. Die Rückzahlung
          ermöglicht neuen Student:innen das Studium.
        </Sub2Typography>
        <Sub2Typography as="p" color="grey7" style={{ margin: '8px 0' }}>
          <b>Einkommensabhängig:</b> Die Rückzahlung ist einkommensabhängig und
          wird die Auszahlung in der Regel übersteigen (kein Stipendium).
        </Sub2Typography>
        <Sub2Typography as="p" color="grey7" style={{ margin: '8px 0' }}>
          <b>Fair:</b> Die Rückzahlung pausiert bei einem weiterführenden
          Studium, in der Elternzeit, bei Krankheit und bei Unterschreiten eines
          vereinbarten Mindesteinkommens.
        </Sub2Typography>
        <Sub2Typography as="p" color="grey7" style={{ margin: '8px 0' }}>
          <b>Academy inbegriffen:</b> Über die volle Vertragslaufzeit erhältst
          du hochwertigen Support über die Deutsche Bildung Academy, z.B.
          Zertifikats-Trainings, Coaching und Bewerbungsberatung.
        </Sub2Typography>
        <Sub2Typography as="p" color="grey7" style={{ margin: '8px 0' }}>
          <b>Chance:</b> Wir freuen uns auf deine Bewerbung. Bitte sei dir aber
          dessen bewusst, dass es keine Garantie auf eine Zusage gibt.
        </Sub2Typography>
        <Sub2Typography as="p" color="grey7" style={{ margin: '8px 0' }}>
          <b>Unverbindlich:</b> Das Angebot und den Vertrag kannst du dir bis
          zur digitalen Unterschrift völlig unverbindlich und in Ruhe anschauen.
        </Sub2Typography>
        <Sub2Typography>
          Jetzt brauchen wir noch einige Infos zu dir und deinem Studium.
        </Sub2Typography>
        <ButtonContainer columns="1fr">
          <Button
            link={{ href: '/registration/check-page' }}
            title="Verstanden, los geht‘s"
            buttonProps={{
              'data-elbaction': TRACKING_ACTION.REGISTRATION.START,
              style: { marginTop: '24px' },
            }}
          />
        </ButtonContainer>
      </Container>
    </Registration.Section>
    <Registration.Section>
      <Sub1Typography as="h2" color="grey7" style={{ textAlign: 'center' }}>
        Du hast dich schon bei uns registriert?
      </Sub1Typography>
      <Button
        variant="text"
        title="Hier geht es zu deinem Login."
        buttonProps={{
          style: { padding: 0, marginTop: 0, marginBottom: '24px' },
        }}
        link={{
          href: '/signin',
        }}
      />
    </Registration.Section>
  </Registration>
);

export default RegistrationView;
